// @flow
import React, { Component } from 'react';
import i18n from 'app/common/lib/i18n';
import type { Experience } from 'app/packages/pinterest-flow-types/experience';
import type { ExperienceClient } from 'app/common/lib/react/experiences/withExperienceClient';
import type { Router } from 'app/common/lib/ReactRouter/types';
import { logQuickPromoteEvents } from 'app/common/lib/BusinessLoggingUtils';
import { withRouter } from 'react-router';
import { Box, Button, Heading, Image, Text } from 'gestalt';

type Props = Experience & {
  complete: () => void,
  experienceClient: ExperienceClient,
  router: Router,
  spendAmount: number,
  refundAmount: number,
};

export class AdCreditsUpsell extends Component<Props> {
  componentDidMount = () => {
    logQuickPromoteEvents(
      'render',
      'ads_credits_profile',
      PCONST.thrift.EventType.RENDER,
      PCONST.thrift.ComponentType.AD_CREDITS_UPSELL,
    );
  };

  handleOfferClick = () => {
    const {
      experience_id: experienceId,
      placement_id: placementId,
      display_data,
      experienceClient,
      router,
    } = this.props;

    const { pin_id, offer_code: offerCode } = display_data;

    logQuickPromoteEvents(
      'click',
      'ads_credits_profile',
      PCONST.thrift.EventType.CLICK,
      PCONST.thrift.ComponentType.AD_CREDITS_UPSELL,
    );

    // NOTE: Using the experience client directly here so we can
    // pass extra context back to the handler.
    experienceClient.completeExperience(placementId, experienceId, false, false, {
      offer_code: offerCode,
    });

    router.push(`/pin/${pin_id}/promote/?redeem_offer=true`);
  };

  render() {
    const { display_data } = this.props;

    const {
      body_text: bodyText,
      header_text: headerText,
      pin_images,
      small_print_text: smallPrintText,
      terms_text: termsText,
    } = display_data;

    const pinImage = pin_images['236x'];
    const srcSet = `${pin_images['236x'].url} 236w, ${pin_images['474x'].url} 474w`;

    return (
      <React.Fragment>
        <Box padding={4} display="flex">
          <Box
            shape="rounded"
            width={236}
            maxHeight={354}
            height={pinImage.height}
            marginRight={5}
            overflow="hidden"
            /* This ensures the image doesn't cover the profile header on scroll */
            dangerouslySetInlineStyle={{ __style: { zIndex: -1 } }}
          >
            <Image
              alt="Pin image"
              color="gray"
              src={pinImage.url}
              srcSet={srcSet}
              naturalWidth={pinImage.width}
              naturalHeight={pinImage.height}
            />
          </Box>
          <Box display="flex" width={470} direction="column">
            <Heading size="sm">{headerText}</Heading>
            <Box marginTop={3}>
              <Text key={0} size="lg">
                {bodyText}
              </Text>
              <Box marginTop={3}>
                <Text key={0} size="lg">
                  {termsText}
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box marginTop={3} paddingX={4}>
          <Button
            color="red"
            text={i18n._('Claim offer', 'button to claim ad credits offer')}
            onClick={this.handleOfferClick}
          />
          <Box marginTop={2} display="flex">
            <Text color="gray" size="sm">
              {smallPrintText}
            </Text>
          </Box>
        </Box>
      </React.Fragment>
    );
  }
}

export default withRouter(AdCreditsUpsell);
